import { useCallback, useState, useImperativeHandle, forwardRef } from 'react';
import AttachmentCountModal from './AttachmentCountModal';
import { jsx as _jsx } from "react/jsx-runtime";
const AttachmentErrorModal = /*#__PURE__*/forwardRef(({
  maxFileLimit,
  attachmentsCount,
  fileUploadsInProgCount
}, ref) => {
  const [showAttachmentModal, setShowAttachmentModal] = useState(false);
  const closeModal = useCallback(() => setShowAttachmentModal(false), [setShowAttachmentModal]);
  const openModal = useCallback(() => {
    setShowAttachmentModal(true);
  }, [setShowAttachmentModal]);
  useImperativeHandle(ref, () => ({
    openModal
  }));
  return showAttachmentModal ? /*#__PURE__*/_jsx(AttachmentCountModal, {
    maxFileLimit: maxFileLimit,
    attachmentsCount: attachmentsCount,
    fileUploadsInProgCount: fileUploadsInProgCount,
    closeModal: closeModal
  }) : null;
});
AttachmentErrorModal.displayName = 'AttachmentErrorModal';
export default AttachmentErrorModal;